module.exports = "<div class=\"horizontal-barchart__row\" ng-repeat=\"rate in $ctrl.rates\">\n  <div class=\"horizontal-barchart__label\">\n    {{rate}}★\n  </div>\n  <div class=\"horizontal-barchart__bar\">\n    <div class=\"horizontal-barchart__bar horizontal-barchart__bar--value\" ng-style=\"{'width': $ctrl.satisfaction[rate].percentage + '%'}\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/dashboard/components/horizontal-barchart/horizontal-barchart.html
// module id = 313
// module chunks = 0